import { sync } from 'vuex-pathify';

import { Draw, Modify, Snap } from 'ol/interaction';
import { Vector as VectorLayer } from 'ol/layer';
import { Vector as VectorSource } from 'ol/source';
import { formatArea, formatLength } from '@/assets/js/mapUtils';

export default {
  computed: {
    isMeasurementsToolActive: sync('tools/toolStatus@isMeasurementsToolActive'),
  },
  data: () => ({
    typeStyleFunctionsDist: {
      Polygon: 'getAreaMeasurementStyles',
      LineString: 'getLengthMeasurementStyles',
      Circle: 'getCircleMeasurementStyles',
    },
  }),
  methods: {
    clearMeasurementInteraction() {
      this.map.removeInteraction(this.getInteractionByName('measurementDrawInteraction'));
      this.map.removeInteraction(this.getInteractionByName('measurementModifyInteraction'));
      this.map.removeInteraction(this.getInteractionByName('measruementSnapInteraction'));
      this.map.removeLayer(this.getLayerById('measurement'));
      this.isMeasurementsToolActive = false;
      this.activeTool = undefined;
      this.isActiveToolNotReplaceable = false;
    },
    getPolygonMeasurementLabel(geometry) {
      return `${this.$i18n.t('map.area')}: ${formatArea(geometry)}
      ${this.$i18n.t('map.perimeter')}: ${formatLength(geometry)}`;
    },
    getMeasurementStyle(feature, type, disablePointStyle) {
      const geometry = feature.getGeometry();
      return [
        ...(disablePointStyle ? [] : this.getPointMeasurementStyle(geometry)),
        ...this[this.typeStyleFunctionsDist[type]](geometry),
      ];
    },
    addMeasurementLayer(type) {
      const layer = new VectorLayer({
        source: new VectorSource({}),
        id: 'measurement',
        style: feature => this.getMeasurementStyle(feature, type),
        zIndex: 1000,
      });
      this.map.addLayer(layer);
      return layer;
    },
    addMeasurement(type) {
      const drawLayer = this.addMeasurementLayer(type);
      this.addMeasurementInteraction(drawLayer, type);
    },
    addMeasurementInteraction(layer, type) {
      this.deactivateToolHandler();
      const drawInteraction = new Draw({
        source: layer.getSource(),
        type: type,
        style: feature => this.getMeasurementStyle(feature, type),
      });
      drawInteraction.set('name', 'measurementDrawInteraction');
      drawInteraction.on('drawstart', () => {
        this.getLayerById('measurement')
          .getSource()
          .clear();
      });

      const modifyInteraction = new Modify({
        source: layer.getSource(),
        style: feature => this.getMeasurementStyle(feature, type, true),
      });
      modifyInteraction.set('name', 'measurementModifyInteraction');

      const snapInteraction = new Snap({
        source: layer.getSource(),
      });
      snapInteraction.set('name', 'measurementSnapInteraction');

      this.map.addInteraction(drawInteraction);
      this.map.addInteraction(modifyInteraction);
      this.map.addInteraction(snapInteraction);
      this.isMeasurementsToolActive = true;
    },
    turnOffMeasurementsInteraction() {
      this.map.removeInteraction(this.getInteractionByName('measurement'));
    },
  },
  mounted() {
    /**
     * Methods with parameters has to be wrapped in order to not be executed
     * during proccess of attachment.
     */
    this.$root.$on('measurementArea-action', (value = true) => {
      if (value) {
        this.addMeasurement('Polygon');
        this.activeTool = 'measurementArea';
      } else {
        this.clearMeasurementInteraction();
      }
    });
    this.$root.$on('measurementLength-action', (value = true) => {
      if (value) {
        this.addMeasurement('LineString');
        this.activeTool = 'measurementLength';
      } else {
        this.clearMeasurementInteraction();
      }
    });
    this.$root.$on('measurementRadius-action', (value = true) => {
      if (value) {
        this.addMeasurement('Circle');
        this.activeTool = 'measurementRadius';
      } else {
        this.clearMeasurementInteraction();
      }
    });
  },
};
